"use client";

import { ReactNode, useContext, useEffect, useState } from "react";
import { useImmer } from "use-immer";
import { AssessmentScoreContext } from "../../../../contexts/assessment-score-context";
import { CourseChapterTestSummary } from "./components/quiz-summary/course-chapter-test-summary";
import { MultiplePatrons } from "@/components/course/multiple-patrons/multiple-patrons";
import { CourseChapterTest } from "./components/course-chapter-test";
import { ResourceContext } from "@/contexts/resource-context";
import { logEvent } from "@/service/logs/log";

export const CourseChapterTestWrapper = ({
  steps,
  beforeStart,
  handleFinish,
  patrons,
  summaryData = {},
  scroll = true,
}: {
  steps: AssessmentStep[];
  beforeStart?: ReactNode;
  handleFinish?: (score?: ClientAssessmentScore) => Promise<void>;
  patrons?: PatronVM[];
  patronType?: "clinical_case" | "course";
  summaryData?: {
    title?: string;
    subtext?: string;
    leftButton?: ReactNode;
    rightButton?: ReactNode;
  };
  scroll?: boolean;
}) => {
  const [status, setStatus] = useState<
    "before_start" | "in_progress" | "finished"
  >(beforeStart ? "before_start" : "in_progress");
  const { logView } = useContext(ResourceContext);
  const [score, setScore] = useImmer<ClientAssessmentScore>({});

  useEffect(() => {
    logEvent("course_quiz_start", logView);
  }, [status]);

  return (
    <AssessmentScoreContext.Provider value={{ score, setScore }}>
      <div>
        {status === "before_start" && beforeStart}
        {status === "in_progress" && (
          <CourseChapterTest
            steps={steps}
            onFinish={() => {
              if (handleFinish) {
                handleFinish(score).then(() => setStatus("finished"));
                logEvent("course_quiz_finish", logView, {
                  questionCount: Object.keys(score).length,
                  correctAnswerCount: Object.values(score).filter(
                    (answer) => answer.correct,
                  ).length,
                });
              } else {
                setStatus("finished");
              }
            }}
            scroll={scroll}
          />
        )}
        {status === "finished" && (
          <div className="mt-8">
            <CourseChapterTestSummary {...summaryData} score={score} />
          </div>
        )}
      </div>
      {patrons && (
        <div className="mt-6 flex items-center justify-center gap-4">
          <MultiplePatrons patrons={patrons} bottom />
        </div>
      )}
    </AssessmentScoreContext.Provider>
  );
};
